import {BulkActionProps, DateInput, ListProps, NullableBooleanInput, NumberInput,} from "ra-ui-materialui";
import {useOptions} from "../../shared/hooks/useOptions";
import {getDefaultListProps, initField} from "../../shared/utils";
import {CustomList} from "../../components/CustomList";
import {BankReceiptDatagrid} from "./BankReceiptDatagrid";
import {Grid, Paper, Tab, Tabs} from "@material-ui/core";
import {useEffect, useState} from "react";
import {DownloadContentBulkButton} from "./DownloadContentBulkButton";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {ReferenceInputAccountCompany} from "../../components/reference-inputs/ReferenceInputAccountCompany";
import {PrintRibaPdfBulkButton} from "./PrintRibaPdfBulkButton";
import {LoadRibaBulkButton} from "./LoadRibaBulkButton";
import {ButtonProps, DatagridProps, NumberField, SelectInput, useListContext} from "react-admin";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import {StatCard} from "../../components/StatCard";
import {PrintRibaPdfButton} from "./PrintRibaPdfButton";
import {BulkChangeStatusReceiptButton} from "./BulkChangeStatusReceiptButton";


export interface CustomBulkActionProps{
    type: string;
    button_props?: ButtonProps;
}

const BulkActionButtons = (props: CustomBulkActionProps) => (
    <>
        <BulkChangeStatusReceiptButton
            type={props.type}
            button_props={props.button_props}
        />
        {props.type === "S" && <PrintRibaPdfBulkButton {...props.button_props} type={props.type}/>}
        <PrintRibaPdfButton {...props.button_props} type={props.type}/>
        {props.type === "S" && <LoadRibaBulkButton {...props.button_props}/>}
        <DownloadContentBulkButton/>
    </>
);


const BankReceiptHeader = (props: DatagridProps) => {
    const {data, selectedIds} = useListContext(props);
    const [stats, setStats] = useState(0);
    useEffect(() => {
        let selectedData = [] as any[];
        for (const d in data) {
            if (selectedIds.includes(data[d].id)) {
                selectedData.push(data[d])
            }
        }
        let total = 0;
        for (const s_d of selectedData) {
            const docSign = ( s_d.payment_schedule.invoice?.type === "FT" || s_d.payment_schedule.invoice?.type === "ND") ? 1 : -1;
            const passiveSign = s_d.payment_schedule.invoice?.invoice_type === "P" ? -1 : 1;
            const sign = docSign * passiveSign;
            total += sign * s_d.payment_schedule.amount
        }
        setStats(total)
    }, [selectedIds])

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
                <StatCard
                    label={
                        <NumberField record={{
                            id: 0,
                            stats: stats
                        }}
                                     source="stats"
                                     variant="inherit"
                                     options={{
                                         style: "currency",
                                         currency: "EUR",
                                     }}

                        />
                    }
                    icon={<AttachMoneyIcon/>}
                    subtitle={"Totale da pagare"}
                    color={"red"}
                />
            </Grid>
        </Grid>
    );
};


export const BankReceiptList = (props: ListProps) => {
    const {data: options} = useOptions("bank_receipt", "GET");
    const [type, setType] = useState("S");

    const filters = options && [
        <ReferenceInputAccountCompany
            {...initField("payment_schedule__invoice__company", options)}
            label="Azienda"
            alwaysOn
        />,
        <DateInput source="payment_schedule__invoice__invoice_date_after" label="Data fattura dal"/>,
        <DateInput source="payment_schedule__invoice__invoice_date_before" label="Data fattura al"/>,
        <DateInput source="expiration_date_after" label="Scadenza dal"/>,
        <DateInput source="expiration_date_before" label="Scadenza al"/>,
        <NumberInput {...initField("id", options)} />,
        <ReferenceInputSubject
            filter={{type: "client"}}
            {...initField("payment_schedule__invoice__client", options)}
            label="Cliente"
        />,
        <NullableBooleanInput
            {...initField("loaded", options)}
            label="Caricata"
            alwaysOn
        />,
        <NullableBooleanInput
            {...initField("generated", options)}
            label="Generata"
            alwaysOn
        />,
        <SelectInput
            {...initField("receipt_status", options, "array")}
            choices={options.receipt_status.choices}
            label="Stato"
            className="filter-field-small"
            alwaysOn
        />,
    ];
    return options && type ? <>
            <Paper square>
                <Tabs
                    value={type}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(e, newValue) => setType(newValue)}
                    aria-label="disabled tabs example"
                >
                    <Tab label="Da incassare" value="S"/>
                    <Tab label="Da pagare" value="P"/>
                </Tabs>
            </Paper>
            <CustomList
                filter={{"payment_schedule__invoice__invoice_type": type}}
                filters={filters}
                filterDefaultValues={{ receipt_status: "CR", payment_schedule__invoice__company: 1 }}
                bulkActionButtons={<BulkActionButtons type={type}/>}
                topElement={<BankReceiptHeader/>}
                {...getDefaultListProps(props)}
                sort={{ field: "expiration_date", order: "ASC" }}
            >
                <BankReceiptDatagrid options={options} type={type}/>
            </CustomList>
        </>
        : null;
};
